'use stric';

var $checkboxes = $('button.checkbox');

$checkboxes.each(function (index, checkbox) {
  var $checkbox = $(checkbox);

  var $input = $checkbox.find('input[type=hidden]');
  if ($input.length) {
    if ($input.val().length <= 0) {
      $input.val('0');
    }
    $checkbox.toggleClass('checked', $input.val() === '1');
  }
});

$(document).on('click', 'button.checkbox', function (event) {
  event.preventDefault();

  var $this = $(this);
  var isChecked = $this.hasClass('checked');

  var $input = $this.find('input[type=hidden]');
  if ($input.length) {
    $input.val(+!isChecked);
  }

  $this.toggleClass('checked', !isChecked);
});
